import { styled } from '@mui/material/styles'
import Stack from '@mui/material/Stack'

export const FooterCopyrightStack = styled(Stack)(({ theme }) => ({
  fontFamily: theme.typography.roboto.fontFamily,
  fontSize: theme.typography.regular.fontSize,
  color: theme.palette.offwhite.main,
  height: '51px'
}))